/* Add to Cart, for a logged-out (Guest) shopper, is a silent teleport to
 * /login with zero explanation - confirmed live and in source
 * (webshop/public/js/shopping_cart.js's bind_add_to_cart_action):
 *
 *   if (frappe.session.user === "Guest") {
 *     ...
 *     frappe.call('webshop.webshop.api.get_guest_redirect_on_action').then((res) => {
 *       window.location.href = res.message || "/login";
 *     });
 *     return;
 *   }
 *
 * "Must log in to add to cart" is core's own deliberate behaviour here
 * (not something raftor_webhq/websitehq introduced, and not something this
 * file changes) - only the missing explanation is the bug. Core's handler
 * still runs and still redirects; this just makes sure the shopper sees
 * why before the page changes out from under them.
 *
 * Capture phase, not bubble: needs to run and paint the alert BEFORE core's
 * own bubble-phase listener (bound the ordinary way, .on('click', ...)) does
 * its async frappe.call().then(redirect) - the network round trip to
 * get_guest_redirect_on_action is what actually buys the alert enough time
 * to be visible before navigation, same as every other frappe.show_alert
 * use in this app (see cart_resilience.js's own show_non_blocking_alert).
 * Never calls preventDefault/stopPropagation - core's handler must still
 * run untouched, this only adds the missing message alongside it.
 */

document.addEventListener(
	'click',
	function (e) {
		if (typeof frappe === 'undefined' || !frappe.session || frappe.session.user !== 'Guest') return;
		var btn = e.target.closest('.btn-add-to-cart-list');
		if (!btn || typeof frappe.show_alert !== 'function') return;

		frappe.show_alert({ message: __('Please log in to add items to your cart.'), indicator: 'blue' }, 5);
	},
	true
);
